<template>
  <div class="flex justify-center h-screen align-items-center text-2xl bg-version">
    <pre style="background: white; padding: 2em; border: 1px solid #9da4ff" class="shadow-2xl">Name: {{pJson.name}}
Version {{ pJson.version }}</pre>
  </div>
</template>

<script>
import pJson from '../../../package.json'

export default {
  name: "Version",
  computed: {
    pJson() {
      return pJson
    }
  }
}
</script>

<style scoped>
  .bg-version {
    background-image: url(/maxresdefault.jpg);
    background-position: center;
    /*background-repeat: no-repeat;*/
    /*background-size: contain;*/
    /*filter: blur(1px);*/
  }
</style>
